module.exports = __webpack_public_path__ + "assets/slike/tenkovi/jna-tenk-podnozje.5b15b0f3310e50c84a34fbefa20a2aad.png";


//////////////////
// WEBPACK FOOTER
// ./assets/slike/tenkovi/jna-tenk-podnozje.png
// module id = 37
// module chunks = 0